












































































































































import Vue from 'vue';
// import * as options from '@/modules/options';
import { SnapShot } from '@/modules/contact/message';
import {
  sizes,
  genDownloadImageUrlByImage,
} from '@/modules/image';

import {
  calender,
  FirestoreDate,
  publicBrand,
  PublicBrand,
  publicBuyer,
  PublicBuyer,
  publicBuyerCompany,
  PublicBuyerCompany,
  publicExhibitorCompany,
  PublicExhibitorCompany,
  publicExhibitor,
  PublicExhibitor,
  contact,
  Contact,
  Message,
} from 'mostra';

interface DisplayMessage {
  date: FirestoreDate;
  messages: Message[];
}

export type DataType = {
  contact: Contact | null;
  buyer: PublicBuyer | null;
  exhibitor: PublicExhibitor | null;
  avatarBuyer: string | null;
  avatarExhibitor: string | null;
  buyerCompany: PublicBuyerCompany | null;
  exhibitorCompany: PublicExhibitorCompany | null;
  brand: PublicBrand | null;
  loading: boolean;
  displayMessages: DisplayMessage[] | null;
  snapshot: any;
};

export default Vue.extend({
  name: 'admin-admin-analysis-contact-detail',
  data(): DataType {
    return {
      contact: null,
      buyer: null,
      exhibitor: null,
      avatarBuyer: null,
      avatarExhibitor: null,
      buyerCompany: null,
      exhibitorCompany: null,
      brand: null,
      loading: false,
      displayMessages: null,
      snapshot: new SnapShot(),
    };
  },
  methods: {
    formatDateTime(dt: any) {
      return calender.formatDateTime(dt);
    },
    // typeStr(t: number) {
    //   return message.typeOfString(t);
    // },
    async setSnapshot() {
      if (
        !this.contact
        || !this.contact.id
        || !this.contact.data.buyer
        || !this.contact.data.exhibitor
      ) throw new Error('contact is null');

      const contactID = this.contact.id;
      const buyerCID = this.contact.data.buyer;
      const exhibitorCID = this.contact.data.exhibitor;
      if (!contactID || !buyerCID || !exhibitorCID) {
        throw new Error('IDs are null');
      }
      console.log(contactID);
      this.snapshot.snapshot(
        contactID,
        buyerCID,
        exhibitorCID,
        await this.snapShotCallback,
        (err: Error) => {
          this.$fatal(err);
        },
      );
    },
    async snapShotCallback(val: Message[]) {
      // const isMessageDelete = this.messages.length > val.length;
      // this.messages = val;
      // this.groupMessagesByDate(this.messages);
      const messages = val;
      this.groupMessagesByDate(messages);
      await this.updateContact();
      // if (isMessageDelete) return;
      // this.scrollToBottom();
    },
    groupMessagesByDate(messages: Message[]) {
      // MEMO 送信日毎にmessagesをまとめる。
      const groupedMessages = messages.reduce<any[]>((result, val, i) => {
        if (i === 0) {
          const initialVal = {
            date: val.data.registeredDate,
            messages: [val],
          };
          return [...result, initialVal];
        }
        const lastMessage = messages[i - 1];
        const currentMessageDate = calender.formatDateJP2(val.data.registeredDate);
        const lastMessageDate = calender.formatDateJP2(lastMessage.data.registeredDate);
        if (currentMessageDate === lastMessageDate) {
          result[result.length - 1].messages.push(val);
          return [...result];
        }
        const newVal = {
          date: val.data.registeredDate,
          messages: [val],
        };
        return [...result, newVal];
      }, []);
      this.displayMessages = groupedMessages;
      console.log('displayMessages', this.displayMessages);
    },
    // scrollToBottom() {
    //   this.$nextTick(() => {
    //     const messageArea: any = this.$refs.messages;
    //     const messageAreaHeight = messageArea.scrollHeight;
    //     messageArea.scrollTop = messageAreaHeight;
    //   });
    // },
    async updateContact() {
      if (!this.contact) return;
      // this.setAsRead();
      // this.setAsReadDateTime();
      const uid = this.$auth.uid;
      try {
        const res = await contact.save(uid, this.contact);
        if (!res) return;
        this.contact = res;
      } catch (err: any) {
        this.$fatal(err);
      }
    },
    async onClickUpdateContact() {
      this.$loading(true);
      try {
        await this.updateContact();
        this.$success('保存しました');
      } catch (error: any) {
        this.$error('保存に失敗しました', error);
      } finally {
        this.$loading(false);
      }
    },
    async fetchData() {
      this.loading = true;
      try {
        // Contact
        this.contact = await contact.load(this.$route.params.id);
        if (!this.contact) throw new Error('contact is null');
        const c = this.contact;
        if (!c || !c.data.buyer || !c.data.exhibitor || !c.data.brandId) throw new Error('contact data is null');

        // Buyer
        this.buyer = await publicBuyer.loadByCID(c.data.buyer);
        this.buyerCompany = await publicBuyerCompany.load(c.data.buyer);
        if (!this.buyer || !this.buyer.data) throw new Error('buyer is null');

        this.avatarBuyer = await genDownloadImageUrlByImage(
          sizes.x512,
          this.buyer.data.profileImage,
        );

        // Brand
        this.brand = await publicBrand.load(c.data.brandId);
        if (!this.brand || !this.brand.data.base.staff) throw new Error('brand is null');

        // Exhibitor
        this.exhibitor = await publicExhibitor.load(this.brand.data.base.staff);
        this.exhibitorCompany = await publicExhibitorCompany.load(c.data.exhibitor);
        if (!this.exhibitor || !this.exhibitor.data) throw new Error('exhibitor is null');

        this.avatarExhibitor = await genDownloadImageUrlByImage(
          sizes.x512,
          this.exhibitor.data.profileImage,
        );

        // console.log('contact', this.contact);
        // console.log('buyer', this.buyer);
        // console.log('buyerCompany', this.buyerCompany);
        // console.log('brand', this.brand);
        // console.log('exhibitor', this.exhibitor);
        // console.log('exhibitorCompany', this.exhibitorCompany);
      } catch (error: any) {
        this.$fatal(error);
      } finally {
        this.loading = false;
      }
    },
  },
  async mounted() {
    this.$loading(true);
    try {
      // const id = this.$route.params.id;
      // this.contact = await contact.loadWithMessage(id);
      await this.fetchData();
      await this.setSnapshot();
    } catch (error: any) {
      this.$error('取得に失敗しました。', error);
    } finally {
      this.$loading(false);
    }
  },
});
